import GcIcon from '../GcIcon/index.vue';

export default {
  name: 'GcUtilityCart',
  data() {
    return {
    };
  },
  components: {
    GcIcon,
  },
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    iconNumber: {
      type: Number,
      default: 0,
    },
  },
};
